import axios from 'axios';
import type { ApiError } from './apiCall';

/**
 * İstek kullanıcı tarafından iptal edildi mi?
 *
 * İptal bir hata değildir: kullanıcı bilerek vazgeçmiştir. Slice'lar bu durumda
 * error state'ini doldurmamalı, ekranda kırmızı bir uyarı çıkmamalıdır.
 */
export const isRequestCanceled = (error: unknown): boolean => {
  if (axios.isCancel(error)) {
    return true;
  }

  if (typeof error === 'object' && error !== null && (error as ApiError).canceled === true) {
    return true;
  }

  if (error instanceof Error && (error.name === 'CanceledError' || error.name === 'AbortError')) {
    return true;
  }

  return false;
};

/** API cevabının hata gövdesi; `ObjectApiResponseDto`'nun bu iş için gereken kısmı. */
interface ApiErrorBody {
  message?: string | null;
  errors?: string[] | null;
}

/**
 * Thunk catch bloklarında kullanılacak ortak hata çevirici.
 *
 * İstek iptal edildiyse `null` döner. Reducer'lar `state.error = action.payload`
 * yaptığı için `null` "hata yok" anlamına gelir ve ekranda uyarı çıkmaz —
 * reducer'lara dokunmaya gerek kalmaz.
 */
export const handleApiError = (error: unknown, defaultMessage: string): string | null => {
  if (isRequestCanceled(error)) {
    return null;
  }

  const response = (error as { response?: { data?: ApiErrorBody } })?.response;
  const body = response?.data;

  if (body) {
    if (body.message) {
      return body.message;
    }
    if (body.errors && body.errors.length > 0) {
      return body.errors.join(', ');
    }
  }

  return (error as { message?: string })?.message || defaultMessage;
};
